export default Date;

Date.prototype.explode = function () {
	return {
		Y: 	this.getFullYear(),
		n: 	this.getMonth() + 1,
		m:	(this.getMonth() + 1).toString().padStart(2, '0'),
		j: 	this.getDate(),
		d: 	this.getDate().toString().padStart(2, '0'),
		G: 	this.getHours(),
		H:	this.getHours().toString().padStart(2, '0'),
		i:	this.getMinutes().toString().padStart(2, '0'),
		s: 	this.getSeconds().toString().padStart(2, '0'),
		w: 	this.getDay()
	};
};

Date.prototype.format = function (format) {
	var r = '';
	var particles = this.explode();

	for (var i = 0; i < format.length; ++i) {
		if (Object.prototype.hasOwnProperty.call(particles, format[i])) {
			r += particles[format[i]];
		} else {
			r += format[i];
		}
	}

	return r;
};

Date.normDate = function (str) {
	return new Date(str.replace(/-/g, '/'));
}